import React, { useContext, useEffect, useState } from 'react'
import { mttAjax } from "utils/_mtt-ajax";
import { trimOrderBeforeAjax } from "app/React/Helpers/DataHelper";
import Spinner from "app/React/Components/misc/Spinner";
import ErrorMessage from "app/React/Components/misc/ErrorMessage";
import Modal from "react-modal";
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function ConfigurationLink() {
  const {
    car,
    cartItems,
    isAccessoryShop,
    openConfigurationLink,
    order,
    orderType,
    setOpenConfigurationLink,
    showGoWish,
    strings,
    usePrice,
    useSecurityDeposit,
  } = useContext(ConfiguratorContext)

  const newsletterStrings = strings.payment_form?.newsletter ?? {}
  const configurationLinkStrings = strings.configurationLink ?? {}

  const onConfigurationLinkConsentChange = function (e) {
    setConsent(document.getElementById('configurationLinkConsent').checked ? 'yes' : 'no')
  }

  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(null)
  const [email, setEmail] = useState('')
  const [consent, setConsent] = useState('no')

  const [goWishLoading, setGoWishLoading] = useState(true)
  const [goWishUrl, setGoWishUrl] = useState(null)
  const [goWishToken, setGoWishToken] = useState(null)

  const security_deposit = useSecurityDeposit()
  const price = usePrice()

  const onClick = (e) => {
    e.preventDefault()

    if (email === '' || loading) {
      return
    }

    setLoading(true)
    setSuccess(false)
    setError(null)

    order.security_deposit = security_deposit
    order.price = price

    mttAjax(
      'configurator_link',
      {
        ...{
          action: 'configurator_link',
          carId: car.id,
          configurationLinkEmail: email,
          configurationLinkConsent: consent,
          order_type: orderType,
        },
        ...trimOrderBeforeAjax(order, cartItems, isAccessoryShop),
      },
      (res) => {
        setLoading(false)

        if (res.success === true) {
          setEmail('')
          setSuccess(true)
          setOpenConfigurationLink(false)
        } else {
          setError(res.data.error)
        }
      }
    )
  }

  const onGoWishClick = (e) => {
    mttAjax(
      'configurator_link_go_wish_click',
      {
        action: 'configurator_link_go_wish_click',
        configurationLinkToken: goWishToken,
      },
      (res) => {}
    )
  }

  useEffect(() => {
    setLoading(false)
    setSuccess(false)
    setError(null)
    setEmail('')
  }, [])

  useEffect(() => {
    if (showGoWish && openConfigurationLink) {
      mttAjax(
        'configurator_link_go_wish',
        {
          ...{
            action: 'configurator_link_go_wish',
            carId: car.id,
            order_type: orderType,
          },
          ...trimOrderBeforeAjax(order, cartItems, isAccessoryShop),
        },
        (res) => {
          if (res.success === true && typeof res.data.configurationLink === 'string') {
            setGoWishUrl(res.data.configurationLink)
            setGoWishToken(res.data.configurationLinkToken)
            setGoWishLoading(false)
          }
        }
      )
    }

    return () => {
      setGoWishLoading(true)
      setGoWishUrl(null)
    }
  }, [openConfigurationLink])

  return (
    <Modal
      isOpen={openConfigurationLink}
      shouldCloseOnOverlayClick
      onRequestClose={() => setOpenConfigurationLink(false)}
      className='configuration-link-modal'
    >
      <div className="close-modal" onClick={() => setOpenConfigurationLink(false)}/>
      <div className='description'>
        <div className='configuration-link'>
          <div className='configuration-link__inner'>
            <div className='configuration-link__text'>
              <div className='configuration-link__title'>{configurationLinkStrings.title}</div>

              {success ? <div className='validation-success'>{configurationLinkStrings.success}</div> : null}
              {error !== null ? <div className='validation-error'>{error}</div> : null}

              <ErrorMessage field='configurationLinkEmail'/>
            </div>

            <div className='configuration-link__form'>
              <input
                type='email'
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                placeholder={configurationLinkStrings.insertEmail}
              />

              {
                typeof configurationLinkStrings.subDescription === 'string' && configurationLinkStrings.subDescription.length > 0 && (
                  <div className='sub-description'
                       dangerouslySetInnerHTML={{ __html: configurationLinkStrings.subDescription }}/>
                )
              }

              <div className="config-form__separator"/>

              <div className='config-checkbox'>
                <label htmlFor='configurationLinkConsent'>
                  <input type='checkbox' name='configurationLinkConsent' id='configurationLinkConsent'
                         onChange={onConfigurationLinkConsentChange}/>
                  <div dangerouslySetInnerHTML={{ __html: newsletterStrings.description }}/>
                </label>
              </div>

              <div className='configuration-link__form-buttons'>
                <button
                  className='configuration-link__form-button'
                  onClick={onClick}
                  step_is_valid={String(email !== '' && !loading)}
                >
                  {loading ? <Spinner/> : configurationLinkStrings.send}
                </button>

                {
                  showGoWish && typeof goWishUrl === 'string' && typeof configurationLinkStrings?.goWish === 'string' && (
                    <button onClick={onGoWishClick} id="gowishBlueButton" className="gowish-btn blue" type="button" data-producturl={goWishUrl}>
                      {goWishLoading ? <Spinner/> : configurationLinkStrings.goWish}
                    </button>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}
